/* eslint-disable @nx/enforce-module-boundaries */
import { Component, effect, inject, signal } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { KanziUiModule } from '@kanzi-apes/kanzi-ui';
import { KanziPrimeUiModule, MenuItem } from '@kanzi-apes/kanzi-prime-ui';
import { ItemsLayoutMainOptions } from '../../configs/main-menu';
import { RouterLink } from '@angular/router';
import { menuValidator } from '@kanzi-apes/kanzi-ui-configs';
import { Store } from '@ngrx/store';
import * as AuthStore from '@kanzi-apes/kanzi-auth';
import * as fromCustomer from '@kanzi-apes/kanzi-customer';

/**
 * Main view component displayed on the layout's default route.
 * Shows quick-access menu cards based on user permissions.
 */
@Component({
  selector: 'kanzi-apes-box-validator-layout-main-view',
  imports: [
    CommonModule,
    KanziUiModule,
    KanziPrimeUiModule,
    TranslateModule,
    TitleCasePipe,
    RouterLink,
  ],
  templateUrl: './layout-main-view.component.html',
  styleUrls: ['./layout-main-view.component.scss'],
})
export class LayoutMainViewComponent {
  storeAuth: Store<AuthStore.AuthState> = inject(Store);
  storeCustomer: Store<fromCustomer.State> = inject(Store);
  user = this.storeAuth.selectSignal(AuthStore.getAuthUser);
  customerSelected = this.storeCustomer.selectSignal(
    fromCustomer.getCustomerSelected
  );
  itemsOptions = signal<MenuItem[]>([]);
  menuEnabled = signal<boolean>(false);

  userProfileEffects = effect(
    () => {
      if (this.user()) {
        const user = this.user();
        if (user && user.configs) {
          this.itemsOptions.set(
            menuValidator(
              ItemsLayoutMainOptions,
              user.configs.active_web_modules
            )
          );
        }
      }
    },
    { allowSignalWrites: true }
  );

  customerSelectedEffects = effect(
    () => {
      if (this.customerSelected()) {
        this.menuEnabled.set(true);
      } else {
        this.menuEnabled.set(false);
      }
    },
    { allowSignalWrites: true }
  );
}
